import {AxiosInstance} from "axios";
import Task from "../model/task/Task";
import {isDefined} from "../utils/Utils";
import moment = require("moment");
import download = require("downloadjs");

export default class TaskApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch tasks.
	 * @returns {Promise<Task[]>} Promise containing all tasks.
	 */
	fetchTasks(): Promise<Task[]> {
		const url = `/api/web/tasks`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(Task.fromJson));
	}

	/**
	 * Download task items.
	 * @returns {Promise<void>}
	 * @param taskId
	 */
	downloadTaskItems(taskId: string) {
		const url = `/api/web/tasks/${taskId}/items_export`;
		const query = {responseType: "blob"};
		return this.axiosInstance.get(url, query).then((resp) => {
			const disposition = resp.headers['content-disposition'];
			const filename = disposition.match(/filename=(.*)/)[1];
			const optName = `TASK_ITEMS_${moment().format("YYYY-MM-DD_HH-MM")}`;
			download(resp.data, isDefined(filename) ? filename : optName);
		});
	}

	/**
	 * Upload task items xlsx
	 * @param {File} file
	 */
	uploadTaskItems(taskId: string, file: File) {
		const url = `/api/web/tasks/${taskId}/items_import`;
		const config = {
			headers: {'content-type': 'multipart/form-data'}
		};
		const formData = new FormData();
		formData.append('file', file);
		return this.axiosInstance.post(url, formData, config);
	}

	/**
	 * Create task
	 * @param {Task} data
	 * @returns {Promise<Task>}
	 */
	createTask(data: Task): Promise<Task> {
		const url = `/api/web/tasks`;
		return this.axiosInstance.post(url, data).then(resp => Task.fromJson(resp.data))
	}

	/**
	 * Update task
	 * @param taskId
	 * @param {Task} data
	 * @returns {Promise<Task>}
	 */
	updateTask(taskId: string, data: Task): Promise<Task> {
		const url = `/api/web/tasks/${taskId}`;
		return this.axiosInstance.put(url, data).then(resp => Task.fromJson(resp.data))
	}
}